
window.algolia.event = function(eventContext, eventName, resultType, params): void {
    const form= new FormData()
    for(const [key, value] of Object.entries(params)) {
        form.append(key, value+'')
    }
    fetch('/search/event/'+eventContext+'/'+eventName+'/'+resultType, {
        method: 'POST',
        body: form,
        keepalive: true,
        credentials: 'include'
    })
}

// search results page context

window.algolia.search_click_product = function(productId: string, position: number, queryID? :string) {
    this.event('search' ,'search_click', 'product', {
        queryID: queryID || this.queryID,
        objectID: productId,
        position: position
    })
}

window.algolia.search_click_category = function(categoryId: string, position: number, queryID? :string) {
    this.event('search', 'search_click', 'category', {
        queryID: queryID || this.queryID,
        objectID: categoryId,
        position: position
    })
}

window.algolia.search_click_page = function(pageId: string, position: number, queryID? :string) {
    this.event('search', 'search_click', 'page', {
        queryID: queryID || this.queryID,
        objectID: pageId,
        position: position
    })
}

// suggest

window.algolia.suggest_click_product = function(productId: string, position: number, queryID? :string) {
    this.event('suggest' ,'search_click', 'product', {
        queryID: queryID || this.queryID,
        objectID: productId,
        position: position
    })
}

window.algolia.suggest_click_category = function(categoryId: string, position: number, queryID? :string) {
    this.event('suggest', 'search_click', 'category', {
        queryID: queryID || this.queryID,
        objectID: categoryId,
        position: position
    })
}

window.algolia.suggest_click_page = function(pageId: string, position: number, queryID? :string) {
    this.event('suggest', 'search_click', 'page', {
        queryID: queryID || this.queryID,
        objectID: pageId,
        position: position
    })
}

window.algolia.suggest_click_term = function(term: string, position: number, queryID? :string) {
    this.event('suggest', 'search_click', 'term', {
        queryID: queryID || this.queryID,
        objectID: term,
        position: position
    })
}

window.algolia.click_product = function(productId: string) {
    /*
    this.event('category', 'click', 'product', {
        objectID: productId
    })
    */
}

document.querySelectorAll('*[x-alg-search-click]').forEach((item) => {
    item.addEventListener('click', () => {
        const [ productId, position ] =item.getAttribute('x-alg-search-click').split(':')
        window.algolia.search_click_product(
            productId,
            parseInt(position)
        )
    })
})

// purchase / view / wishlist

window.algolia.view_product = function(productId: string) {
    this.event('other' ,'view', 'product', {
        objectID: productId,
    })
}

window.algolia.view_video = function(productId: string) {
    this.event('other' ,'view', 'product_video', {
        objectID: productId,
    })
}

window.algolia.add_to_wishlist = function(productId: string) {
    this.event('wishlist' ,'conversion', 'product', {
        'objectIDs[0]': productId,
    })
}

// todo: wire up clicks on category/pages on results page

document.querySelectorAll('*[x-alg-click]').forEach((item) => {
    item.addEventListener('click', () => {
        const productId = item.getAttribute('x-alg-click')
        window.algolia.click_product(
            productId
        )
    })
})